import * as React from 'react';
import { FileTextIcon } from 'lucide-react';

export const PageTitle = () => {
  return (
    <div className={'flex items-center gap-2 font-GilroySemibold'}>
      <FileTextIcon className={'w-5 h5'} />
      <h1 className={'text-md'}>
        <span className={'font-GilroySemibold'}>Tracking</span>
        <span className={'font-GilroyRegular uppercase ml-2'}>Notas Fiscais</span>
      </h1>
    </div>
  );
};